import { authFetch } from './http/fetchClient';
import { APIUrl } from 'Utils/Utils';

export const llmModelsApi = {
  getModels: async (): Promise<any> => {
    const res = await authFetch(`${APIUrl()}/llm_models`);
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    return res.json();
  },
};
